import { Injectable } from '@angular/core';
import { Empregador } from '../api.service';

export interface IdentidadeMarca {
  nome: string;
  logo: string;
  iniciais: string;
}

@Injectable({ providedIn: 'root' })
export class ServicoIdentidadeMarca {
  montar(empregadores: Empregador[], empregadorSelecionado: string, empregadorEdicao: Empregador): IdentidadeMarca {
    const empregador = this.empregadorAtual(empregadores, empregadorSelecionado, empregadorEdicao);
    const nome = empregador?.razaoSocial || empregador?.nomeFantasia || 'Ponto JWM';
    return {
      nome,
      logo: empregador?.logoBase64 || '',
      iniciais: this.iniciais(nome)
    };
  }

  private empregadorAtual(empregadores: Empregador[], empregadorSelecionado: string, empregadorEdicao: Empregador) {
    const editandoSelecionado = Boolean(empregadorEdicao.id && empregadorEdicao.id === empregadorSelecionado);
    return editandoSelecionado
      ? empregadorEdicao
      : empregadores.find(item => item.id === empregadorSelecionado);
  }

  private iniciais(nome: string) {
    return nome
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(parte => parte[0])
      .join('')
      .toUpperCase() || 'PJ';
  }
}
